module.exports = __webpack_public_path__ + "static/media/un_sdg.1a257b36.png";